import React, {useState} from 'react';
import UserModalForm from '../Modals/UserModalForm';

import { IconButton, Tooltip } from '@material-ui/core';
import { AddBox as AddBoxIcon } from '@material-ui/icons';

const Toolbar = (props) => {

    const [open, setOpen] = useState(false);
    const [userInfo, setUserInfo] = useState(null);

    const handleClick = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <IconButton aria-label="create" onClick={handleClick}>
                <Tooltip title="Create">
                    <AddBoxIcon />
                </Tooltip>
            </IconButton>

            <UserModalForm
                dialogTitle={'Create User'}
                open={open}
                handleClose={handleClose}
                fetchUsers={props.fetchUsers}
                userInfo={userInfo}
                selectedUser={null}
            />
        </>
    );
}

export default Toolbar;